import {Injectable} from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ParametroService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Objetivo do Parametro do sistema por id
     * @param id ID da Objetivo do Parametro do sistema
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "parametro-sistema/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Parametro do sistema
     * @param id ID da Objetivo do Parametro do sistema
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "parametro-sistema"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete Parametro do sistema
     * @param id ID do Objetivo do Parametro do sistema
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "parametro-sistema/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Parametro do sistema
     * @param params Json Objetivo do Parametro do sistema
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "parametro-sistema", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Parametro do sistema
     * @param params Json Objetivo do Parametro do sistema
     */
    update(params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "parametro-sistema", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
